module.exports = __webpack_public_path__ + "media/images/japan/icons-60f1365afc3def9cd9713a9256a00273.svg";